import { render, staticRenderFns } from "./SkuPropertiesList.vue?vue&type=template&id=5e2aebf3&scoped=true"
import script from "./SkuPropertiesList.vue?vue&type=script&lang=js"
export * from "./SkuPropertiesList.vue?vue&type=script&lang=js"
import style0 from "./SkuPropertiesList.vue?vue&type=style&index=0&id=5e2aebf3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2aebf3",
  null
  
)

export default component.exports